import { TagEdit } from 'pages/tags';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'library_tags',
  label: 'Tags da biblioteca',
  edit: TagEdit,
  route: 'teaching_resources/libraries/:libraryId/tags',
  actions: ['list', 'show', 'create', 'edit'],
  parentName: 'teaching_resources',
  hide: true
};

export default generateResources(resource);
